const offlineLessonSubmit = () => {

  var required = [
    '#offline_lesson_region',
    '#offline_lesson_place',
    '#offline_lesson_date',
    '#offline_lesson_time'
  ];

  jQuery.each(required, function(i, sel) {
    jQuery(document).on('change', sel, function() {
      var $field = jQuery(this);
      if ($field.val()) {
        $field.removeClass('wpcf7-not-valid');
        $field.closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip').remove();
      }
    });
  });

  jQuery('#offline_lesson_submit').on('click', function(e) {
    e.preventDefault();

    var form = jQuery(this).closest('form.wpcf7-form');
    var allFilled = true;

    form.addClass('submitting');
    form.find('.custom-response').remove();

    jQuery.each(required, function(i, sel) {
      var $field = jQuery(sel);
      if (!$field.val()) {
        allFilled = false;
        var wrap = $field.closest('.wpcf7-form-control-wrap');
        if (wrap.length && !wrap.find('.wpcf7-not-valid-tip').length) {
          wrap.append('<span class="wpcf7-not-valid-tip">' + rcTranslate.fill_in_the_field + '</span>');
        }
        $field.addClass('wpcf7-not-valid');
      } else {
        $field.removeClass('wpcf7-not-valid');
        $field.closest('.wpcf7-form-control-wrap').find('.wpcf7-not-valid-tip').remove();
      }
    });

    if (!allFilled) {
      form.append('<div class="custom-response error"> ' + rcTranslate.fill_in_the_field + '</div>');
      form.removeClass('submitting');
      return;
    }

    var formData = form.serialize();

    jQuery.ajax({
      url: rcData.ajaxUrl,
      method: 'POST',
      data: {
        action: 'offline_lesson_submit',
        formData: formData
      },
      beforeSend: function() {
        form.find('.wpcf7-spinner').addClass('is-active');
      },
      success: function(response) {
        form.find('.wpcf7-spinner').removeClass('is-active');
        form.removeClass('submitting');

        if (response.success) {
          form.append('<div class="custom-response success">' + rcTranslate.offline_signed_success + '</div>');

          if (response.data && response.data.address) {
            jQuery('#address').text(response.data.address);
          }


          jQuery('#attempts-left').text(response.data.attempts);


          form[0].reset();
          form.find('.select-2').val(null).trigger('change');

          form.find('select').each(function() {
            if (this.id !== 'offline_lesson_region') {
              jQuery(this).prop('disabled', true).trigger('change.select2');
            }
          });

          const $popup = jQuery('.offline-lesson-popup');

          if ($popup.length) {
            setTimeout(function() {
              $popup.removeClass('active').hide();
              jQuery('body').css('overflow', 'auto');
            }, 2000);
          }

          if (response.data && response.data.count >= 3) {
            jQuery('#offline-button').hide();
            jQuery('#popup-wrapper').css('display', 'none');
          }

        } else {
          form.append('<div class="custom-response error"> Error sending. Please try again later.</div>');
        }

        setTimeout(function() {
          form.find('.custom-response').fadeOut(400, function() {
            jQuery(this).remove();
          });
        }, 5000);
      },
      error: function() {
        form.find('.wpcf7-spinner').removeClass('is-active');
        form.removeClass('submitting');
        form.append('<div class="custom-response error"> Error sending. Please try again later.</div>');
      },
      complete: function() {
        form.removeClass('submitting');
      }
    });
  });

};

export default offlineLessonSubmit;
